import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ISelect } from 'src/app/domain/interfaces/select.interface';
import { ProposalService } from 'src/app/domain/services/proposals.service';
import { PropostaAdiantamentoService } from 'src/app/domain/services/proposta-adiantamento.service'
import { DialogComponent } from "src/app/ui/dialog/dialog.component";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { IProposalRequestByCode } from 'src/app/domain/interfaces/proposal.interface';
import { BrokerService } from 'src/app/domain/services/broker.service';
import { LoadComponent } from 'src/app/ui/load/load.component';
import { TipoDePropostaEnum } from 'src/app/domain/enums/enums';
import { ProductService } from 'src/app/domain/services/product.service';
import { EnviromentsService } from 'src/app/domain/services/enviroments.service';
import { PeriodicidadeEnum } from 'src/app/domain/enums/periodicidade.enum';
import { FormaPagamentoEnum } from 'src/app/domain/enums/forma-pagamento.enum';

@Component({
    selector: 'parcelamento-premio-proposta',
    templateUrl: './parcelamento-premio-proposta.component.html',
    styleUrls: ['../../../../styles/components/parcelamento-premio-proposta.component.scss'],
  })


  export class ParcelamentoPremioPropostaComponent implements OnInit{

    idProposta = null;
    visualizar = false;
    alterar = false;
    @Input() idTipoProposta = null;
    @Input() valorImportanciaSeguradaRecursal = new EventEmitter();
    @Input() quantidadeDiasVigencia: string;
    @Output() premio = new EventEmitter();
    @Output() alteracaoI4pro = new EventEmitter();
    @Output() parcelas = new EventEmitter();
    @Output() diaPrimeiroVencimento = new EventEmitter();
    @Output() formaPagamento = new EventEmitter();
    @Output() premioTotal = new EventEmitter();
    @Output() efetivado = false;
    @Output() periodicidadeChange = new EventEmitter();
    //@Output() parcelamentoComponent = new EventEmitter();

    minInitialDate = new Date().toISOString().slice(0, 10);
    maxInitialDate = new Date().toISOString().slice(0, 10);
    dataCriacaoProposta = new Date();

    listFormaParcelamento: ISelect[] = [];
    listFormaPagamento: ISelect[] = [];
    listPeriodicidade: ISelect[] = [];
    firstFormGroup: UntypedFormGroup;
    alterarPropostaI4Pro:any = [];
    alterarPropostaI4ProAdiantamento:any = [];
    alterarPropostaI4ProJudicial:any = [];
    informacoesCorretora:any = [];
    tipoProposta: any = [];
    dadosCobranca: any = [];
    premioRecuperado = false;

    inicioVigencia = null;
    finalVigencia = null;
    propostaHub:any = [];
    propostaI4pro: any = [];
    numeroParcelas: number = 0;
    liberaFormaParcelamento = false;
    proposalByCodeRequest: IProposalRequestByCode;
    alterarPropostaHubRecursal: any;
    habilitaAlteracao = false;
    habilitaAlteracaoBotao = false;
    loadEnviromentsObj: any = [];

    //Classes
    formClass = "";
    sectionFirstClass = "fist__section";
    sectionSecondClass = "second__section";
    divClass = "form__group";
    matClass = "form__field";
    matLabelClass = "";
    buttonClass = "button";
    divButton = "";

    constructor(private propososalService: ProposalService,
                private propostaAdiantamentoService: PropostaAdiantamentoService,
                private brokerService : BrokerService,
                private productService: ProductService,
                private enviromentsService: EnviromentsService,
                private fb: UntypedFormBuilder,
                private datePipe: DatePipe,
                private dialog: MatDialog){}

    ngOnInit(){
      this.firstFormGroup = this.fb.group({
        parcelamentoPrimeiraParcela: this.fb.control(""),
        parcelamentoDemaisParcelas: this.fb.control(""),
        formaPagamento: this.fb.control(""),
        dataPrimeiroVencimento: this.fb.control(""),
        periodiciade: this.fb.control("", [Validators.required]),
        diaVencimentoDemaisParcelas: this.fb.control(""),
      });

      this.firstFormGroup.controls.parcelamentoPrimeiraParcela.disable();
      this.firstFormGroup.controls.periodiciade.disable();
      this.firstFormGroup.controls.formaPagamento.disable();
      this.firstFormGroup.controls.dataPrimeiroVencimento.disable();
      this.firstFormGroup.controls.diaVencimentoDemaisParcelas.disable();

      this.firstFormGroup.controls.parcelamentoDemaisParcelas.disable();

      this.loadEnviroments();

      if(this.idTipoProposta == TipoDePropostaEnum.Adiantamento){
        this.formClass = "third-step";
        this.sectionFirstClass = "third-step__section";
        this.sectionSecondClass = "third-step__section";
        this.divClass = "section__form-container";
        this.matClass = "form-container__form";
        this.buttonClass = "button__vert";
        this.matLabelClass = "form-container__label";
        this.divButton = "section__button-box"
      }
      else if(this.idTipoProposta == TipoDePropostaEnum.Civel || this.idTipoProposta == TipoDePropostaEnum.Fiscal ||
              this.idTipoProposta == TipoDePropostaEnum.Trabalhista){

        this.formClass = "thirdFormGroup";
        this.sectionFirstClass = "first__container d-flex";
        this.sectionSecondClass = "first__container d-flex";
        this.divClass = "form__group margin";
        this.matClass = "form__field";
        this.buttonClass = "button__vert";
        this.divButton = "form__group";
      }
      else if(this.idTipoProposta == null){
        this.visualizar = true;
      }

    }

    loadEnviroments() {
      this.enviromentsService.GeAlltEnviroments()
        .subscribe((res) => {
          this.loadEnviromentsObj = res;
        });
    }

    showModal(
      title: string,
      text: string,
      firstNameButton: string,
      secondNameButton: string
    ) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: { title, text },
        height: "238px",
        width: "480px",
      });
      dialogRef.componentInstance.firstNameButton = firstNameButton;
      dialogRef.componentInstance.secondNameButton = secondNameButton;
    }

    habilitaEfetivarAlteracoes(value){
      let verificaPeriodicidade = this.listPeriodicidade.filter(x => x.value == this.firstFormGroup.controls.periodiciade.value);
      if(verificaPeriodicidade.length > 0 &&
      (this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value != null || this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value.undefined) &&
      (this.firstFormGroup.controls.periodiciade.value != null || this.firstFormGroup.controls.periodiciade.value.undefined) &&
      (this.firstFormGroup.controls.formaPagamento.value != null || this.firstFormGroup.controls.formaPagamento.value.undefined) &&
      (this.firstFormGroup.controls.dataPrimeiroVencimento.value != null || this.firstFormGroup.controls.dataPrimeiroVencimento.value.undefined)){
        this.habilitaAlteracaoBotao = true;
      }
      else{
        this.habilitaAlteracaoBotao = false;
      }
    }

    emitChangePeriodicidade(){
      this.periodicidadeChange.emit(this.firstFormGroup.controls.periodiciade.value);
    }

    recuperaDadosCobranca(){
      this.dadosCobranca = {
        parcelamentoPrimeiraParcela: this.listFormaParcelamento.filter(x => x.value == this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value)[0]?.viewValue,
        parcelamentoDemaisParcelas: this.listFormaPagamento.filter(x => x.value == this.firstFormGroup.controls.parcelamentoDemaisParcelas.value)[0]?.viewValue,
        formaPagamento: this.listFormaPagamento.filter(x => x.value == this.firstFormGroup.controls.formaPagamento.value)[0]?.viewValue,
        dataPrimeiroVencimento: this.propostaHub.installmentExpDate,
        periodiciade: this.listPeriodicidade.filter(x => x.value == this.firstFormGroup.controls.periodiciade.value)[0]?.viewValue,
        diaVencimentoDemaisParcelas: this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value,
      }

      return this.dadosCobranca;
    }

    //Método responsável por verificar a data de vencimento e ver se é maior do que o prazo de vigência.
    verificaDataVencimento(){
      let dataValida = true;
      if(this.finalVigencia != null){

        const inicioVigenciaArray = this.inicioVigencia?.split('-');
        const finalVigenciaArray = this.finalVigencia?.split('-');
        const dataPrimeiroVencimentoArray = this.firstFormGroup.controls.dataPrimeiroVencimento?.value.split('-');
        let dataInicioVigencia: any;
        let dataFinalVigencia:any;
        let dataPrimeiroVencimento:any;

        if (inicioVigenciaArray?.length == 3){
          dataInicioVigencia = new Date(inicioVigenciaArray[0], inicioVigenciaArray[1] - 1, inicioVigenciaArray[2]);
        }
        else{
          dataInicioVigencia = new Date(this.inicioVigencia);
        }

        if (finalVigenciaArray?.length == 3){
          dataFinalVigencia = new Date(finalVigenciaArray[0], finalVigenciaArray[1] - 1, finalVigenciaArray[2]);
        }
        else{
          dataFinalVigencia = new Date(this.finalVigencia);
        }

        if (dataPrimeiroVencimentoArray?.length == 3){
          dataPrimeiroVencimento = new Date(dataPrimeiroVencimentoArray[0], dataPrimeiroVencimentoArray[1] - 1, dataPrimeiroVencimentoArray[2]);
        }
        else{
          dataPrimeiroVencimento = new Date(this.firstFormGroup.controls.dataPrimeiroVencimento?.value);
        }

        if(dataFinalVigencia.getDay() == 6){
          let data = new Date(dataFinalVigencia);
          dataFinalVigencia = new Date(data.setDate(data.getDate() - 1));
        }
        else if(dataFinalVigencia.getDay() == 0){
          let data = new Date(dataFinalVigencia);
          dataFinalVigencia = new Date(data.setDate(data.getDate() - 2));
        }

        if(dataPrimeiroVencimento > dataFinalVigencia){

          let data = this.datePipe.transform(new Date(dataFinalVigencia), "dd/MM/yyyy");

          this.showModal(
            "Atenção",
            "A data do vencimento da primeira parcela não pode ser maior do que a data " + data + ".",
            null,
            "ENTENDI"
          );

          dataValida = false;
          this.habilitaAlteracao = false;
          this.habilitaAlteracaoBotao = false;
        }
        else if(dataPrimeiroVencimento < dataInicioVigencia){
          let data = this.datePipe.transform(new Date(dataInicioVigencia), "dd/MM/yyyy");

          this.showModal(
            "Atenção",
            "A data do vencimento da primeira parcela não pode ser menor do que a data " + data + ".",
            null,
            "ENTENDI"
          );

          dataValida = false;
          this.habilitaAlteracao = false;
          this.habilitaAlteracaoBotao = false;
        }
        else if (this.firstFormGroup.controls.dataPrimeiroVencimento.value.length == 0){
          this.habilitaAlteracao = false;
          this.habilitaAlteracaoBotao = false;
        } else {
          this.habilitaAlteracao = true;
          this.habilitaAlteracaoBotao = true;
          this.habilitaEfetivarAlteracoes(true);
        }
      }
      else{
        this.habilitaAlteracao = true;
        this.habilitaAlteracaoBotao = true;
        this.habilitaEfetivarAlteracoes(true);
      }

      return dataValida;
    }

    verificaPremioTaxaMix(premio, produto){
      this.listFormaParcelamento = [];

      this.propososalService
      .getI4ProGetParcelingByProduct(produto)
      .subscribe((res) => {
        if (Array.isArray(res.data.Parcelamento_Buscar)) {
          res.data.Parcelamento_Buscar.forEach((element) => {
            this.listFormaParcelamento.push({
              value: element.Id_produto_parc_premio,
              viewValue: element.Ds_parcelamento,
            });
          });

          this.verificaParcelamento(premio);
        }
      });
    }

    //Método responsável por verificar a quantidade de parcelamento disponível de acordo com o prêmio da proposta.
    verificaParcelamento(valorPremio: number){
      if(valorPremio >= 600){

        let numeroParcelas: any[] = [ { value: 1 }, { value: 2}, { value: 3}, { value: 4}, { value: 5}, { value: 6}, { value: 7}];
        let listaParcelamento = null

        for(let i = 0; i < numeroParcelas.length; i++){
          let premio = valorPremio / numeroParcelas[i].value;
          if(premio >= 300){
            listaParcelamento = this.listFormaParcelamento.slice(0, numeroParcelas[i].value);

          }
        }

        if(listaParcelamento.length <= 0 || listaParcelamento == null){
          listaParcelamento = this.listFormaParcelamento.slice(0, 1);

          this.listFormaParcelamento = listaParcelamento;
        }
        else {
          this.listFormaParcelamento = listaParcelamento;
        }
      }
      else{
        let listaParcelamento = this.listFormaParcelamento.slice(0, 1);

        this.listFormaParcelamento = listaParcelamento;
      }
    }

    //Método responsável por alterar a forma de pagamento das demais parcelas de acordo com o que é escolhido na primeira parcela.
    alteraFormaPagamento(value: number){
      this.habilitaEfetivarAlteracoes(value);

      this.firstFormGroup.controls.parcelamentoDemaisParcelas.setValue(value);
    }

    //Método responsável por habilitar a opção de parcelamento na tela.
    selecionaFormaParcelamento(nome: string){
      this.habilitaEfetivarAlteracoes(nome);

      if(nome == this.loadEnviromentsObj.parcelamentoAVista.aVista_1 || nome == this.loadEnviromentsObj.parcelamentoAVista.avista_2 ||
         nome == this.loadEnviromentsObj.parcelamentoAVista.avista_3 || nome == this.loadEnviromentsObj.parcelamentoAVista.avista_4){
        this.liberaFormaParcelamento = false;
        this.firstFormGroup.controls.parcelamentoDemaisParcelas.disable();
        this.firstFormGroup.controls.diaVencimentoDemaisParcelas.clearValidators();
        this.firstFormGroup.controls.parcelamentoDemaisParcelas.clearValidators();
      }
      else{
        this.liberaFormaParcelamento = true;
        this.firstFormGroup.controls.parcelamentoDemaisParcelas.enable();
        this.firstFormGroup.controls.diaVencimentoDemaisParcelas.setValidators([Validators.required]);
        this.firstFormGroup.controls.parcelamentoDemaisParcelas.setValidators([Validators.required]);
      }
    }

    //Método para carregar propostas do tipo Jucial Civil, Trabalhista e Fiscal
    carregaPropostaJudicial(){
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.proposalByCodeRequest = {
        cd_proposta: this.idProposta,
        cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
        id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString()
      }

      this.propososalService.getProposalByCodeJudicial(this.proposalByCodeRequest)
        .subscribe((res) => {
          this.propostaI4pro = res.value.propostaI4Pro.Proposta_Pesquisar[0];
          this.propostaHub = res.value;
          this.setDueDate();

          this.brokerService
          .getBrokerById(this.propostaHub.propostaJudicial.idCorretora)
          .subscribe((resBroker) => {

            this.informacoesCorretora = resBroker.data;

            this.alterarPropostaI4Pro = {
              dt_inicio_vigencia: this.datePipe.transform(new Date(this.propostaHub.propostaJudicial.inicioValidade),"yyyy-MM-dd"),
              dt_final_vigencia: this.datePipe.transform(new Date(this.propostaHub.propostaJudicial.fimValidade),"yyyy-MM-dd"),
              cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
              id_endereco_tomador: this.propostaI4pro.id_endereco_tomador,
              id_endereco_cliente: this.propostaI4pro.id_endereco_segurado,
              id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString(),
              cd_status: this.loadEnviromentsObj.propostaStatus[0].statusCode,
              dados_cobranca_dt_vencimento_pparcela: this.firstFormGroup.controls.dataPrimeiroVencimento.value,
              dados_cobranca_dias_demais_pparcela: this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value == "" ? 0 :
                                                   this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value,
              dados_cobranca_cd_forma_pagamento_pparcela: this.firstFormGroup.controls.formaPagamento.value,
              dados_cobranca_cd_forma_pagamento: this.firstFormGroup.controls.formaPagamento.value,
              dados_cobranca_id_produto_parc_premio: this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value,
              dados_cobranca_id_periodo_pagamento: this.firstFormGroup.controls.periodiciade.value,
              dados_garantia_id_produto_cobertura: this.tipoProposta.idProdutoCobertura,
              dados_garantia_vl_premio_tarifario: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
              dados_garantia_pe_comissao: this.propostaI4pro.dados_garantia_Pe_comissao,
              dados_garantia_vl_adicional: this.propostaI4pro.dados_garantia_vl_adicional,
              dados_garantia_vl_is: this.propostaHub.propostaJudicial.valorImportanciaSegurada,
              dados_garantia_cd_moeda: this.propostaI4pro.dados_garantia_cd_moeda,
              dados_garantia_vl_taxa_risco: this.propostaI4pro.dados_garantia_vl_taxa_risco,
              dados_garantia_vl_premio_total: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
              dados_garantia_vl_iof: this.propostaI4pro.dados_garantia_vl_iof,
              objeto_segurado_nm_objeto_segurado: this.propostaI4pro.objeto_segurado_nm_objeto_segurado,
              texto_trabalhista_anexo: this.propostaI4pro.texto_trabalhista_anexo,
              id_apolice: this.propostaI4pro.id_apolice,
              cd_usuario_inclusao: this.informacoesCorretora.idUsuarioCorretor.toString(),
              dv_calculo_manual: this.alterar ? "true" : "false",
            };

            this.i4ProPropostaJudicial();
            loadRef.close()
          });
      });
    }

    setDueDate(){
      const currentDate = new Date(`${this.propostaHub.installmentExpDate} 00:00:00`)

          if(currentDate < new Date()){
            let newDueDate = new Date().setDate(new Date().getDate() + 7);
            const isSaturday = new Date(newDueDate).getDay() === 6;
            const isSunday = new Date(newDueDate).getDay() === 0;
            if(isSaturday){
              newDueDate = new Date().setDate(new Date().getDate() + 9);
            }
            else if(isSunday){
              newDueDate = new Date().setDate(new Date().getDate() + 8);
            }
            this.propostaHub.installmentExpDate = (this.datePipe.transform(
              newDueDate,
              "yyyy-MM-dd"
            ));
          }
    }

    //Método para carregar propostas do tipo Licitações, Contratos, Recursal e Recursal SME
    carregaPropostaHubRecursal() {
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.propososalService.getProposalById(this.idProposta)
        .subscribe((res) => {
          this.propostaHub = res.data;

          this.brokerService.getBrokerById(this.propostaHub.brokerId)
            .subscribe((resBroker) => {

              this.informacoesCorretora = resBroker.data;

              this.proposalByCodeRequest = {
                cd_proposta: this.propostaHub.code,
                cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
                id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString(),
              };

              if (this.propostaHub.code != null) {
                this.propososalService.getProposalByCode(this.proposalByCodeRequest)
                  .subscribe((res) => {
                    this.propostaI4pro = res.value.Proposta_Pesquisar[0];

                    this.alterarPropostaI4Pro = {
                      dt_inicio_vigencia: this.datePipe.transform(new Date(this.propostaHub.policyIniExpDate), "yyyy-MM-dd"),
                      dt_final_vigencia: this.datePipe.transform(new Date(this.propostaHub.policyFinExpDate), "yyyy-MM-dd"),
                      cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
                      id_endereco_tomador: this.propostaI4pro.id_endereco_tomador,
                      id_endereco_cliente: this.propostaI4pro.id_endereco_segurado,
                      id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString(),
                      cd_status: this.loadEnviromentsObj.propostaStatus[0].statusCode,
                      dados_cobranca_dt_vencimento_pparcela: this.firstFormGroup.controls.dataPrimeiroVencimento.value,
                      dados_cobranca_dias_demais_pparcela: this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value == "" ? 0 :
                        this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value,
                      dados_cobranca_cd_forma_pagamento_pparcela: this.firstFormGroup.controls.formaPagamento.value,
                      dados_cobranca_cd_forma_pagamento: this.firstFormGroup.controls.formaPagamento.value,
                      dados_cobranca_id_produto_parc_premio: this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value,
                      dados_cobranca_id_periodo_pagamento: this.firstFormGroup.controls.periodiciade.value,
                      dados_garantia_id_produto_cobertura: this.tipoProposta.idProdutoCobertura,
                      dados_garantia_vl_premio_tarifario: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
                      dados_garantia_pe_comissao: this.propostaI4pro.dados_garantia_Pe_comissao,
                      dados_garantia_vl_adicional: this.propostaI4pro.dados_garantia_vl_adicional,
                      dados_garantia_vl_is: this.valorImportanciaSeguradaRecursal,
                      dados_garantia_cd_moeda: this.propostaI4pro.dados_garantia_cd_moeda,
                      dados_garantia_vl_taxa_risco: this.propostaI4pro.dados_garantia_vl_taxa_risco,
                      dados_garantia_vl_premio_total: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
                      dados_garantia_vl_iof: this.propostaI4pro.dados_garantia_vl_iof,
                      objeto_segurado_nm_objeto_segurado: this.propostaI4pro.objeto_segurado_nm_objeto_segurado,
                      texto_trabalhista_anexo: this.propostaI4pro.texto_trabalhista_anexo,
                      id_apolice: this.propostaI4pro.id_apolice,
                      cd_usuario_inclusao: this.informacoesCorretora.idUsuarioCorretor.toString(),
                      dv_calculo_manual: this.alterar ? "true" : "false",
                    };

                    this.i4ProPropostaRecursal();
                    loadRef.close()
                  });
              }
            });
        });
    }

    //Método para carregar propostas do tipo Andiantamento
    carregaPropostaHubAdiantamento(){
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.propostaAdiantamentoService.getPropostaAdiantamentobyCode(this.idProposta, true)
        .subscribe((res) => {
          this.propostaHub = res.result;
          this.informacoesCorretora = this.propostaHub.retornoMarketPlace.corretora;

            this.alterarPropostaI4Pro = {
              dt_inicio_vigencia: this.datePipe.transform(new Date(this.propostaHub.retornoMarketPlace.inicioValidade),"yyyy-MM-dd"),
              dt_final_vigencia: this.datePipe.transform(new Date(this.propostaHub.retornoMarketPlace.fimValidade),"yyyy-MM-dd"),
              cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
              id_endereco_tomador: this.propostaI4pro.id_endereco_tomador,
              id_endereco_cliente: this.propostaI4pro.id_endereco_segurado,
              id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString(),
              cd_status: this.loadEnviromentsObj.propostaStatus[0].statusCode,
              dados_cobranca_dt_vencimento_pparcela: this.firstFormGroup.controls.dataPrimeiroVencimento.value,
              dados_cobranca_dias_demais_pparcela: this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value == "" ? 0 :
                                                   this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value,
              dados_cobranca_cd_forma_pagamento_pparcela: this.firstFormGroup.controls.formaPagamento.value,
              dados_cobranca_cd_forma_pagamento: this.firstFormGroup.controls.formaPagamento.value,
              dados_cobranca_id_produto_parc_premio: this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value,
              dados_cobranca_id_periodo_pagamento: this.firstFormGroup.controls.periodiciade.value,
              dados_garantia_id_produto_cobertura: this.tipoProposta.idProdutoCobertura,
              dados_garantia_vl_premio_tarifario: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
              dados_garantia_pe_comissao: this.propostaI4pro.dados_garantia_Pe_comissao,
              dados_garantia_vl_adicional: this.propostaI4pro.dados_garantia_vl_adicional,
              dados_garantia_vl_is: this.propostaHub.retornoMarketPlace.valorTotalImportanciaSegurada,
              dados_garantia_cd_moeda: this.propostaI4pro.dados_garantia_cd_moeda,
              dados_garantia_vl_taxa_risco: this.propostaI4pro.dados_garantia_vl_taxa_risco,
              dados_garantia_vl_premio_total: this.propostaI4pro.dados_garantia_vl_premio_tarifario,
              dados_garantia_vl_iof: this.propostaI4pro.dados_garantia_vl_iof,
              objeto_segurado_nm_objeto_segurado: this.propostaI4pro.objeto_segurado_nm_objeto_segurado,
              texto_trabalhista_anexo: this.propostaI4pro.texto_trabalhista_anexo,
              id_apolice: this.propostaI4pro.id_apolice,
              cd_usuario_inclusao: this.informacoesCorretora.idUsuarioCorretor.toString(),
              dv_calculo_manual: this.alterar ? "true" : "false",
              dt_inclusao: this.propostaHub.retornoi4Pro.Proposta_Pesquisar[0].dt_proposta,
              id_pessoa_tomador:this.propostaHub.retornoi4Pro.Proposta_Pesquisar[0].id_pessoa_tomador,
              id_pessoa_cliente: this.propostaHub.retornoi4Pro.Proposta_Pesquisar[0].id_pessoa_segurado,
              cd_produto:this.propostaHub.retornoi4Pro.Proposta_Pesquisar[0].cd_produto
            };

            this.i4ProPropostaAdiantamento();
            loadRef.close()
        });
    }

    i4ProPropostaRecursal(){
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.propososalService
        .putProposalI4pro(this.alterarPropostaI4Pro)
        .subscribe((res) => {

          if(res.value){
            if(res.value.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso){
              this.showModal(
                "Sucesso",
                "Alterações Efetivada com sucesso!",
                null,
                "ENTENDI"
              );

              this.efetivado = true;
              this.premio.emit(res.value.Proposta.dados_garantia_vl_premio_tarifario);
              this.alteracaoI4pro.emit(res.value.Proposta);
              this.verificaParcelamento(res.value.Proposta.dados_garantia_vl_premio_tarifario);

              this.alteraPropostaHubRecursal();
            }
            else{
              this.showModal(
                "Atenção",
                "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
                null,
                "ENTENDI"
              );
            }
          }
          else{
            this.showModal(
              "Atenção",
              "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
              null,
              "ENTENDI"
            );
          }

          loadRef.close();
        });
    }

    i4ProPropostaAdiantamento(){
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.alterarPropostaI4ProAdiantamento = {
        CdMoeda: 1,
        IdProposta: this.propostaHub.retornoMarketPlace.id,
        PostPropostaI4Pro: this.alterarPropostaI4Pro,
        PropostaAdiantamento: {
          id: this.propostaHub.retornoMarketPlace.id,
          IdApolice: this.propostaHub.retornoMarketPlace.idApolice,
          CriadoPorUsuarioId: 0,
          CodigoApolice: this.propostaHub.retornoMarketPlace.codigoApolice,
          CodigoProposta: this.propostaHub.retornoMarketPlace.codigoProposta,
          CodigoSusep: this.propostaHub.retornoMarketPlace.codigoSusep,
          IdUsuario: this.propostaHub.retornoMarketPlace.idUsuario,
          IdTipoDeProposta: this.propostaHub.retornoMarketPlace.idTipoDeProposta,
          IdEstruturaComercial: this.propostaHub.retornoMarketPlace.idEstruturaComercial,
          IdCorretora: this.propostaHub.retornoMarketPlace.idCorretora,
          IdTomador: this.propostaHub.retornoMarketPlace.idTomador,
          IdSegurado: this.propostaHub.retornoMarketPlace.idSegurado,
          InicioValidade: this.propostaHub.retornoMarketPlace.inicioValidade,
          DiasDeVigencia: this.propostaHub.retornoMarketPlace.diasDeVigencia,
          FimValidade: this.propostaHub.retornoMarketPlace.fimValidade,
          NumeroContratoOcPedido: this.propostaHub.retornoMarketPlace.numeroContratoOcPedido,
          DataContratoOcPedido: this.propostaHub.retornoMarketPlace.dataContratoOcPedido,
          IdPropostaEventoDeAdiantamento: this.propostaHub.retornoMarketPlace.idPropostaEventoDeAdiantamento,
          FormaDeAmortizacao: this.propostaHub.retornoMarketPlace.formaDeAmortizacao,
          ValorTotalContratoOcPedido: this.propostaHub.retornoMarketPlace.valorTotalContratoOcPedido,
          PorcentagemDeAdiantamento: this.propostaHub.retornoMarketPlace.porcentagemDeAdiantamento,
          ValorTotalImportanciaSegurada: this.propostaHub.retornoMarketPlace.valorTotalImportanciaSegurada,
          Finalidade: this.propostaHub.retornoMarketPlace.finalidade,
          ObjetoSeguradoTexto: this.propostaHub.retornoMarketPlace.objetoSeguradoTexto,
          CdStatus: this.propostaHub.retornoMarketPlace.cdStatus,
          Status: this.propostaHub.retornoMarketPlace.status,
          PropostaAdiantamentoClausulas: this.propostaHub.retornoMarketPlace.propostaAdiantamentoClausulas,
          IdPropostaAdiantamentoObjetoSegurado: this.propostaHub.retornoMarketPlace.idPropostaAdiantamentoObjetoSegurado,
          AllClauses: [],
        }
      };

      this.propososalService
        .postCalcularPremioPropostaAdiantamento(this.alterarPropostaI4ProAdiantamento)
        .subscribe((res) => {

          if(res.result){
            if(res.result.retornoi4Pro.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso){
              this.showModal(
                "Sucesso",
                "Alterações Efetivada com sucesso!",
                null,
                "ENTENDI"
              );
              this.efetivado = true;
              this.premio.emit(res.result.retornoi4Pro.Proposta.dados_garantia_vl_premio_tarifario);
              this.verificaParcelamento(res.result.retornoi4Pro.Proposta.dados_garantia_vl_premio_tarifario);
              this.emitChangePeriodicidade();
            }
            else{
              this.showModal(
                "Atenção",
                "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
                null,
                "ENTENDI"
              );
            }
          }
          else{
            this.showModal(
              "Atenção",
              "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
              null,
              "ENTENDI"
            );
          }

          loadRef.close();
        });
    }

    i4ProPropostaJudicial(){
      const loadRef = this.dialog.open(LoadComponent, {
        panelClass: "custom-modalbox",
        disableClose: true,
      });

      this.alterarPropostaI4ProJudicial = {
        CdMoeda: 1,
        IdProposta: this.propostaHub.propostaJudicial.id,
        Alteracao: true,
        PostPropostaI4Pro: this.alterarPropostaI4Pro,
        isDuplicateProposal: false,
        PropostaJudicial: {
          Agravo: this.propostaHub.propostaJudicial.agravo,
          AllClauses: [],
          AutoDeInfracao: this.propostaHub.propostaJudicial.autoDeInfracao,
          AutorProponente: this.propostaHub.propostaJudicial.autorProponente,
          CdTipoDePessoaTomador: "2",
          CodigoApolice: this.propostaHub.propostaJudicial.codigoApolice,
          CodigoProposta: this.propostaHub.propostaJudicial.codigoProposta,
          CodigoSusep: this.propostaHub.propostaJudicial.codigoSusep,
          CdStatus: this.propostaHub.propostaJudicial.cdStatus,
          CpfCnpj: this.propostaHub.propostaJudicial.cpfCnpj,
          CriadoPorUsuarioId: this.propostaHub.propostaJudicial.criadoPorUsuarioId,
          FimValidade: this.propostaHub.propostaJudicial.fimValidade,
          IdApolice: this.propostaHub.propostaJudicial.idApolice,
          IdCorretora: this.propostaHub.propostaJudicial.idCorretora,
          IdEstruturaComercial: this.propostaHub.propostaJudicial.idEstruturaComercial,
          IdIndiceAtualizacao: this.propostaHub.propostaJudicial.idIndiceAtualizacao,
          IdPrazoDeVigencia: this.propostaHub.propostaJudicial.idPrazoDeVigencia,
          IdSegurado: this.propostaHub.propostaJudicial.idSegurado,
          IdTipoAcao: this.propostaHub.propostaJudicial.idTipoAcao,
          IdTipoDeProposta: this.propostaHub.propostaJudicial.idTipoDeProposta,
          IdTomador: this.propostaHub.propostaJudicial.idTomador,
          IdUsuario: this.propostaHub.propostaJudicial.idUsuario,
          IndiceInformado: this.propostaHub.propostaJudicial.indiceInformado,
          InicioValidade: this.propostaHub.propostaJudicial.inicioValidade,
          NumeroExecucaoProvisoria: this.propostaHub.propostaJudicial.numeroExecucaoProvisoria,
          ObjetoSeguradoTexto: this.propostaHub.propostaJudicial.objetoSeguradoTexto,
          Processo: this.propostaHub.propostaJudicial.processo,
          ProcessoAdministrativo: this.propostaHub.propostaJudicial.processoAdministrativo,
          PropostaJudicialCDAs: this.propostaHub.propostaJudicial.propostaJudicialCDAs,
          ReclamantesSecundarios: this.propostaHub.propostaJudicial.reclamantesSecundarios,
          TipoAcao: this.propostaHub.propostaJudicial.tipoAcao,
          TipoDeSegurado: this.propostaHub.propostaJudicial.tipoDeSegurado,
          TomadorComoAutorProponente: this.propostaHub.propostaJudicial.tomadorComoAutorProponente,
          ValorImportanciaSegurada: this.propostaHub.propostaJudicial.valorImportanciaSegurada,
          ValorSegurado: this.propostaHub.propostaJudicial.valorSegurado,
          Vara: this.propostaHub.propostaJudicial.vara,
          VaraBairro: this.propostaHub.propostaJudicial.varaBairro,
          VaraCep: this.propostaHub.propostaJudicial.varaCep,
          VaraCidade: this.propostaHub.propostaJudicial.varaCidade,
          VaraComplemento: this.propostaHub.propostaJudicial.varaComplemento,
          VaraLogradouro: this.propostaHub.propostaJudicial.varaLogradouro,
          VaraNumero: this.propostaHub.propostaJudicial.varaNumero,
          VaraTribunal: this.propostaHub.propostaJudicial.varaTribunal,
          VaraUf: this.propostaHub.propostaJudicial.varaUf
        }
      };

      if(this.idTipoProposta == TipoDePropostaEnum.Civel){
        this.propososalService
        .postCalcBillingProposalJudicialCivel(this.alterarPropostaI4ProJudicial)
        .subscribe((res) => {

          if(res.data){
            if(res.data?.retornoi4Pro?.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso){
              this.showModal(
                "Sucesso",
                "Alterações Efetivada com sucesso!",
                null,
                "ENTENDI"
              );

              this.efetivado = true;
              this.premioRecuperado = true;
              this.premio.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.parcelas.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].ParcelaProposta.ParcelaProposta);
              this.diaPrimeiroVencimento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_dt_vencimento_pparcela)
              this.formaPagamento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_nm_parcelamento)
              this.verificaParcelamento(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.premioTotal.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_net);
              this.alteracaoI4pro.emit();
              this.emitChangePeriodicidade();
            }
            else{
              this.showModal(
                "Atenção",
                "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
                null,
                "ENTENDI"
              );
            }
          }
          else{
            this.showModal(
              "Atenção",
              "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
              null,
              "ENTENDI"
            );
          }

          loadRef.close();
        },
        error =>{
          loadRef.close();
        });
      }
      else if(this.idTipoProposta == TipoDePropostaEnum.Fiscal){
        this.propososalService
        .postCalcBillingProposalJudicial(this.alterarPropostaI4ProJudicial)
        .subscribe((res) => {

          if(res.data){
            if(res.data?.retornoi4Pro?.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso){
              this.showModal(
                "Sucesso",
                "Alterações Efetivada com sucesso!",
                null,
                "ENTENDI"
              );

              this.efetivado = true;
              this.premio.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.parcelas.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].ParcelaProposta.ParcelaProposta);
              this.diaPrimeiroVencimento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_dt_vencimento_pparcela)
              this.formaPagamento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_nm_parcelamento)
              this.verificaParcelamento(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.premioTotal.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_net);
              this.alteracaoI4pro.emit();
              this.emitChangePeriodicidade();
            }
            else{
              this.showModal(
                "Atenção",
                "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
                null,
                "ENTENDI"
              );
            }
          }
          else{
            this.showModal(
              "Atenção",
              "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
              null,
              "ENTENDI"
            );
          }

          loadRef.close();
        },
        error =>{
          loadRef.close();
        });
      }
      else if(this.idTipoProposta == TipoDePropostaEnum.Trabalhista){
        this.propososalService
        .postCalcBillingProposalJudicialTrabalhista(this.alterarPropostaI4ProJudicial)
        .subscribe((res) => {

          if(res.data){
            if(res.data?.retornoi4Pro?.cd_retorno == this.loadEnviromentsObj.requestCdRetorno.sucesso){
              this.showModal(
                "Sucesso",
                "Alterações Efetivada com sucesso!",
                null,
                "ENTENDI"
              );

              this.efetivado = true;
              this.premio.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.parcelas.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].ParcelaProposta.ParcelaProposta);
              this.diaPrimeiroVencimento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_dt_vencimento_pparcela)
              this.formaPagamento.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_cobranca_nm_parcelamento)
              this.verificaParcelamento(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_tarifario);
              this.premioTotal.emit(res.data.retornoi4Pro.Proposta_Pesquisar[0].dados_garantia_vl_premio_net);
              this.alteracaoI4pro.emit();
              this.emitChangePeriodicidade();
            }
            else{
              this.showModal(
                "Atenção",
                "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
                null,
                "ENTENDI"
              );
            }
          }
          else{
            this.showModal(
              "Atenção",
              "Não foi possível realizar a alteração, por favor, entre em contato com o administrador do sistema",
              null,
              "ENTENDI"
            );
          }

          loadRef.close();
        },
        error =>{
          loadRef.close();
        });
      }
    }

    //Método responsável por alterar a proposta na i4pro.
    alterarPropostaI4pro(){

      if (!this.firstFormGroup.valid){
        this.showModal(
          "Atenção",
          "Os campos obrigatórios devem ser preenchidos.",
          null,
          "ENTENDI"
        );

        return;
      }
      if(this.idTipoProposta == TipoDePropostaEnum.Licitacoes || this.idTipoProposta == TipoDePropostaEnum.Contratos ||
        this.idTipoProposta == TipoDePropostaEnum.Recursal || this.idTipoProposta == TipoDePropostaEnum.SME
        || this.idTipoProposta == TipoDePropostaEnum.LicitacoesPrivado || this.idTipoProposta == TipoDePropostaEnum.ContratosPrivado
        || this.idTipoProposta == TipoDePropostaEnum.ContratoConstrucao|| this.idTipoProposta == TipoDePropostaEnum.ContratoFornecimento|| this.idTipoProposta == TipoDePropostaEnum.ContratoPrestacaoServicos
        || this.idTipoProposta == TipoDePropostaEnum.ContratoPrivadoConstrucao|| this.idTipoProposta == TipoDePropostaEnum.ContratoPrivadoFornecimento|| this.idTipoProposta == TipoDePropostaEnum.ContratoPrivadoPrestacaoServicos){

        this.carregaPropostaHubRecursal();
      }
      else if(this.idTipoProposta == TipoDePropostaEnum.Civel || this.idTipoProposta == TipoDePropostaEnum.Fiscal || this.idTipoProposta == TipoDePropostaEnum.Trabalhista){

        this.carregaPropostaJudicial();
      }
      else if(this.idTipoProposta == TipoDePropostaEnum.Adiantamento){
        this.carregaPropostaHubAdiantamento();
      }

      this.loadParcelingOptions(this.tipoProposta.cdProduto);

    }

    //Método responsável por alterar a proposta do tipo Licitações, Contratos, Recursal e Recursal SME na tabela Proposals do Hub.
    alteraPropostaHubRecursal(){

      this.alterarPropostaHubRecursal = {
        id: this.idProposta,
        payMethodFirstInstallment: this.firstFormGroup.controls.parcelamentoPrimeiraParcela.value,
        payMethodInstallment: this.firstFormGroup.controls.periodiciade.value,
        installmentExpDate: this.firstFormGroup.controls.dataPrimeiroVencimento.value,
        installmentForm: this.firstFormGroup.controls.formaPagamento.value,
        formOtherPayInstallments: this.firstFormGroup.controls.parcelamentoDemaisParcelas.value,
        dayDueInstallments: this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value == "" ? 0 : this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value,
      };

      this.propososalService
      .PutFormaPagamentoProposta(this.alterarPropostaHubRecursal)
      .subscribe((res) => {
        this.emitChangePeriodicidade();
      });

    }

    //Método responsável por carregar as opções de periodicidade.
    loadFrequencyOptions(cdProduto: number) {
      this.listPeriodicidade = [];

      this.propososalService
        .getI4ProGetFrequencyPayByProduct(cdProduto)
        .subscribe((res) => {
          if (Array.isArray(res.data.PeriodicidadePagamento_Buscar)) {
            res.data.PeriodicidadePagamento_Buscar.forEach((element) => {
              this.listPeriodicidade.push({
                value: element.Id_periodo,
                viewValue: element.Nm_periodo,
              });
            });
          }
        });
    }

    //Método responsável por carregar as opções de parcelamento.
    loadParcelingOptions(cdProduto: number) {
      this.listFormaParcelamento = [];

      this.propososalService
        .getI4ProGetParcelingByProduct(cdProduto)
        .subscribe((res) => {
          if (Array.isArray(res.data.Parcelamento_Buscar)) {
            res.data.Parcelamento_Buscar.forEach((element) => {
              this.listFormaParcelamento.push({
                value: element.Id_produto_parc_premio,
                viewValue: element.Ds_parcelamento,
              });
            });

            if(this.idTipoProposta == TipoDePropostaEnum.Civel || this.idTipoProposta == TipoDePropostaEnum.Fiscal ||
              this.idTipoProposta == TipoDePropostaEnum.Trabalhista || this.idTipoProposta == TipoDePropostaEnum.Adiantamento){

              this.verificaParcelamento(this.propostaI4pro.dados_garantia_vl_premio_tarifario)
            }
          }
        });
    }

    //Método responsável por carregar as opções de pagamento.
    loadPayWayOptions(cdProduto: number, proposalTypeId: number) {
      this.listFormaPagamento = [];

      this.propososalService.getI4ProGetPayWayByProduct(cdProduto, proposalTypeId)
        .subscribe((res) => {
          if (Array.isArray(res.data.FormaPagamento_Buscar)) {
             res.data.FormaPagamento_Buscar.forEach((element) => {
              this.listFormaPagamento.push({
                value: element.Cd_forma_pagamento,
                viewValue: element.Nm_forma_pagamento,
              });

              this.firstFormGroup.controls.formaPagamento.setValue(Number.parseInt(this.listFormaPagamento[0].value));
            });
          }
      });
    }

    calculaPrazoPagamentoPrimeiraParcela(data, expData){
      this.dataCriacaoProposta = new Date(data);
      //const dataExpiracao = new Date(expData);
      let dataExpiracao = new Date(data);
      if(parseInt(this.quantidadeDiasVigencia) < 30){
        dataExpiracao.setDate(dataExpiracao.getDate() + parseInt(this.quantidadeDiasVigencia));
      }else {
        dataExpiracao.setDate(dataExpiracao.getDate() + 37);
      }
      if(dataExpiracao.getDay() === 0){
        let data = new Date(dataExpiracao);
        dataExpiracao = new Date(data.setDate(data.getDate() - 2));
      }
      if(dataExpiracao.getDay() === 6){
        let data = new Date(dataExpiracao);
        dataExpiracao = new Date(data.setDate(data.getDate() - 1));
      }
      const diffTime =  Math.abs(dataExpiracao.getTime() - this.dataCriacaoProposta.getTime());
      const milisegundosDia = 1000 * 60 * 60 * 24;
      const intervaloDias = Math.ceil(diffTime / milisegundosDia);
      this.maxInitialDate = this.datePipe.transform(this.dataCriacaoProposta.setDate(this.dataCriacaoProposta.getDate() + intervaloDias),"yyyy-MM-dd");
      this.finalVigencia = this.maxInitialDate;
      this.minInitialDate = this.datePipe.transform(new Date(data.setDate(data.getDate() + 7)),"yyyy-MM-dd");
      this.inicioVigencia = this.minInitialDate;
    }

    //Método responsável por carregar informações do tipo de propostas Licitações, Contratos, Recursal e Recursal SME.
    loadProposalHubRecursal(propostaId, visualizarBool, alterarBool, tipoPropostaId){

      this.idTipoProposta = tipoPropostaId;
      this.idProposta = propostaId;
      this.visualizar = visualizarBool;
      this.alterar = alterarBool;

      if(this.idProposta != ""){
        this.propososalService.getProposalById(this.idProposta)
        .subscribe((res) => {

          this.propostaHub = res.data;
          if(new Date(this.propostaHub.createdDate) < new Date()){
            this.propostaHub.createdDate = new Date();
          } else{
            this.propostaHub.createdDate = new Date(this.propostaHub.createdDate);
          }

          this.calculaPrazoPagamentoPrimeiraParcela(this.propostaHub.createdDate, this.propostaHub.installmentExpDate)

          this.loadProposalI4Pro();

          this.productService.GetPropostaSetorByProduto(this.propostaHub.productId, this.propostaHub.proposalTypeId).subscribe((resProduct) => {
            this.tipoProposta = resProduct.data;
            this.loadParcelingOptions(this.tipoProposta.cdProduto);
            this.loadPayWayOptions(this.tipoProposta.cdProduto, this.propostaHub.proposalTypeId);
            this.loadFrequencyOptions(this.tipoProposta.cdProduto)
          })
          this.firstFormGroup.controls.parcelamentoPrimeiraParcela.setValue(Number.parseInt(this.propostaHub.payMethodFirstInstallment));

          var dateNow = new Date();
          var date = this.datePipe.transform(dateNow,"yyyy-MM-dd");
          if (this.propostaHub.installmentExpDate < this.minInitialDate && this.alterar)
          {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(this.minInitialDate,"yyyy-MM-dd"));
          }
          if (date > this.propostaHub.installmentExpDate && this.alterar){
            dateNow.setDate(dateNow.getDate() + 7);
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(dateNow,"yyyy-MM-dd"));
          }
          else {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(new Date(this.propostaHub.installmentExpDate),"yyyy-MM-dd"));
          }

          if(this.propostaHub.dayDueInstallments > 0){
            this.firstFormGroup.controls.parcelamentoDemaisParcelas.setValue(Number.parseInt(this.propostaHub.formOtherPayInstallments));
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.setValue(Number.parseInt(this.propostaHub.dayDueInstallments));
          }

          if(this.visualizar || this.alterar){
            this.firstFormGroup.controls.periodiciade.setValue(Number.parseInt(this.propostaHub.payMethodInstallment));
            this.finalVigencia = this.maxInitialDate;
            this.firstFormGroup.controls.formaPagamento.setValue(Number.parseInt(this.propostaHub.installmentForm));
          }
          else{
            this.firstFormGroup.controls.periodiciade.setValue(PeriodicidadeEnum.Unica);
          }

          this.habilitaAlteracao = true;

          if(this.visualizar){
            this.habilitaAlteracao = false;
            this.habilitaAlteracaoBotao = false;
          }

          if(!this.visualizar){
            this.firstFormGroup.controls.parcelamentoPrimeiraParcela.enable();
            this.firstFormGroup.controls.periodiciade.enable();
            this.firstFormGroup.controls.formaPagamento.enable();
            this.firstFormGroup.controls.dataPrimeiroVencimento.enable();
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.enable();
          }

        });
      }
    }

    //Método responsável por carregar informações do tipo de proposta Judicial Civil, Judicial Fiscal e Judicial Trabalhista.
    loadProposalJudicial(proposta : IProposalRequestByCode, visualizarBool, alterarBool, tipoPropostaId){
      this.idTipoProposta = tipoPropostaId;
      this.idProposta = proposta.cd_proposta;
      this.visualizar = visualizarBool;
      this.alterar = alterarBool;

      this.formClass = "thirdFormGroup";
      this.sectionFirstClass = "first__container d-flex";
      this.sectionSecondClass = "first__container d-flex";
      this.divClass = "form__group margin";
      this.matClass = "form__field";
      this.buttonClass = "button__vert";
      this.divButton = "form__group";

      if(this.idProposta != ""){
        this.propososalService.getProposalByCodeJudicial(proposta)
        .subscribe((res) => {

          const loadRef = this.dialog.open(LoadComponent, {
            panelClass: "custom-modalbox",
            disableClose: true,
          });

          this.propostaI4pro = res.value.propostaI4Pro.Proposta_Pesquisar[0];
          this.propostaHub = res.value;
          this.dataCriacaoProposta

          this.calculaPrazoPagamentoPrimeiraParcela(new Date(this.propostaHub.propostaJudicial.createdDate), this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela)

          this.formaPagamento.emit(this.propostaI4pro.dados_cobranca_nm_parcelamento)

          this.propososalService.GetProposalTypes().subscribe((res) => {
            this.tipoProposta = res.data.filter(x=> x.idProdutoCobertura == this.propostaI4pro.dados_garantia_id_produto_cobertura)[0];
            this.loadParcelingOptions(this.tipoProposta.cdProduto);
            this.loadPayWayOptions(this.tipoProposta.cdProduto, this.tipoProposta.id);
            this.loadFrequencyOptions(this.tipoProposta.cdProduto)
          });

          this.brokerService
            .getBrokerById(this.propostaHub.propostaJudicial.idCorretora)
            .subscribe((resBroker) => {

              this.informacoesCorretora = resBroker.data;
          });

          this.firstFormGroup.controls.parcelamentoPrimeiraParcela.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_id_produto_parc_premio));
          this.firstFormGroup.controls.periodiciade.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_id_periodo_pagamento));

          var dateNow = new Date();
          var date = this.datePipe.transform(dateNow,"yyyy-MM-dd");
          if (this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela < this.minInitialDate && this.alterar)
          {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(this.minInitialDate,"yyyy-MM-dd"));
          }
          if (date > this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela && this.alterar){
            dateNow.setDate(dateNow.getDate() + 7);
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(dateNow,"yyyy-MM-dd"));
          }
          else {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(new Date(this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela),"yyyy-MM-dd"));
          }

          if(parseInt(this.propostaI4pro.dados_cobranca_nr_dia_cobranca) > 0){
            this.firstFormGroup.controls.parcelamentoDemaisParcelas.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_cd_forma_pagamento_pparcela));
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_nr_dia_cobranca));
          }

          this.habilitaAlteracao = true;

          if(this.visualizar){
            this.habilitaAlteracao = false;
            this.habilitaAlteracaoBotao = false;
          }

          if(this.visualizar || this.alterar){
            this.finalVigencia = this.maxInitialDate;
            this.firstFormGroup.controls.formaPagamento.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_cd_forma_pagamento_pparcela));
          }

          if(!this.visualizar){
            this.firstFormGroup.controls.parcelamentoPrimeiraParcela.enable();
            this.firstFormGroup.controls.periodiciade.enable();
            this.firstFormGroup.controls.formaPagamento.enable();
            this.firstFormGroup.controls.dataPrimeiroVencimento.enable();
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.enable();
          }

          loadRef.close();
        });
      }
    }

    //Método responsável por carregar informações do tipo de proposta Adiantamento.
    loadProposalHubAndiantamento(codigoProposta, visualizarBool, alterarBool){
      this.idTipoProposta = TipoDePropostaEnum.Adiantamento;
      this.idProposta = codigoProposta;
      this.visualizar = visualizarBool;
      this.alterar = alterarBool;

      this.formClass = "third-step";
      this.sectionFirstClass = "third-step__section";
      this.sectionSecondClass = "third-step__section";
      this.divClass = "section__form-container";
      this.matClass = "form-container__form";
      this.buttonClass = "button__vert";
      this.matLabelClass = "form-container__label";

      if(this.idProposta != ""){
        this.propostaAdiantamentoService.getPropostaAdiantamentobyCode(this.idProposta, true)
        .subscribe((res) => {
          this.propostaI4pro = res.result.retornoi4Pro.Proposta_Pesquisar[0];
          this.propostaHub = res.result;

          this.calculaPrazoPagamentoPrimeiraParcela(new Date(this.propostaHub.retornoMarketPlace.createdDate), this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela)

          this.informacoesCorretora = this.propostaHub.retornoMarketPlace.corretora;

          this.verificaParcelamento(this.propostaI4pro.dados_garantia_vl_premio_tarifario);

          this.propososalService.GetProposalTypes().subscribe((res) => {
            this.tipoProposta = res.data.filter(x=> x.idProdutoCobertura == this.propostaI4pro.dados_garantia_id_produto_cobertura)[0];
            this.loadParcelingOptions(this.tipoProposta.cdProduto);
            this.loadPayWayOptions(this.tipoProposta.cdProduto, this.tipoProposta.id);
            this.loadFrequencyOptions(this.tipoProposta.cdProduto)
          });

          this.firstFormGroup.controls.parcelamentoPrimeiraParcela.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_id_produto_parc_premio));

          this.firstFormGroup.controls.periodiciade.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_id_periodo_pagamento));

          if(this.firstFormGroup.controls.periodiciade.value !== this.loadEnviromentsObj.periodicidade[0].idPeriodo
            && this.firstFormGroup.controls.periodiciade.value !== this.loadEnviromentsObj.periodicidade[1].idPeriodo){
              this.setPeriodicidadeValidator();
          }

          var dateNow = new Date();
          var date = this.datePipe.transform(dateNow,"yyyy-MM-dd");
          if (this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela < this.minInitialDate && this.alterar)
          {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(this.minInitialDate,"yyyy-MM-dd"));
          }
          if (date > this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela && this.alterar){
            dateNow.setDate(dateNow.getDate() + 7);
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(dateNow,"yyyy-MM-dd"));
          }
          else {
            this.firstFormGroup.controls.dataPrimeiroVencimento.setValue(this.datePipe.transform(new Date(this.propostaI4pro.dados_cobranca_dt_vencimento_pparcela),"yyyy-MM-dd"));
          }

          if(parseInt(this.propostaI4pro.dados_cobranca_nr_dia_cobranca) > 0){
            this.firstFormGroup.controls.parcelamentoDemaisParcelas.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_cd_forma_pagamento_pparcela));
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_nr_dia_cobranca));
          }

          this.habilitaAlteracao = true;

          if(this.visualizar){
            this.habilitaAlteracao = false;
            this.habilitaAlteracaoBotao = false;
          }

          if(this.visualizar || this.alterar){
            this.finalVigencia = this.maxInitialDate;
            this.firstFormGroup.controls.formaPagamento.setValue(Number.parseInt(this.propostaI4pro.dados_cobranca_cd_forma_pagamento_pparcela));
          }

          if(!this.visualizar){
            this.firstFormGroup.controls.parcelamentoPrimeiraParcela.enable();
            this.firstFormGroup.controls.periodiciade.enable();
            this.firstFormGroup.controls.formaPagamento.enable();
            this.firstFormGroup.controls.dataPrimeiroVencimento.enable();
            this.firstFormGroup.controls.diaVencimentoDemaisParcelas.enable();
          }
        });
      }

    }

    //Método responsável por carregar informações da proposta na i4pro.
    loadProposalI4Pro(){
      this.brokerService
      .getBrokerById(this.propostaHub.brokerId)
      .subscribe((resBroker) => {

        const loadRef = this.dialog.open(LoadComponent, {
          panelClass: "custom-modalbox",
          disableClose: true,
        });

        this.informacoesCorretora = resBroker.data;

        this.proposalByCodeRequest = {
          cd_proposta: this.propostaHub.code,
          cd_susep: this.informacoesCorretora.cdSusepCorretor.toString(),
          id_usuario: this.informacoesCorretora.idUsuarioCorretor.toString(),
        };

        if(this.propostaHub.code != null){
          this.propososalService.getProposalByCode(this.proposalByCodeRequest)
          .subscribe((res) => {
            this.propostaI4pro = res.value.Proposta_Pesquisar[0];
            this.verificaParcelamento(this.propostaI4pro.dados_garantia_vl_premio_tarifario);
          });
        }
        loadRef.close();
      });
    }

    varificaDiasDemaisParcelas(){
      if(this.liberaFormaParcelamento){
        if(this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value <= 0 || this.firstFormGroup.controls.diaVencimentoDemaisParcelas.value > 30){
          return false;
        }
        else{
          return true;
        }
      }
      else{
        return true;
      }
    }

    setPeriodicidadeValidator(){
      this.firstFormGroup.controls.periodiciade.clearValidators();
      this.firstFormGroup.controls.periodiciade.setValidators([Validators.required]);
      this.firstFormGroup.controls.periodiciade.updateValueAndValidity();
      this.firstFormGroup.controls.periodiciade.markAsTouched();
      this.firstFormGroup.controls.periodiciade.setValue('');
    }

    verifyStatusPeriodicidade(){
      if(this.firstFormGroup.controls.periodiciade.value){
        return true;
      }

      return false;
    }
  }
